export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '无需注册',
      description: '打开即看，无需繁琐的注册流程，保护您的隐私安全。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      description: '支持手机、平板、电脑多端流畅播放，随时随地想看就看。',
    },
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      description: '提供1080P高清画质，享受影院级的视觉体验。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速加载',
      description: '全球CDN加速，视频秒开不卡顿，流畅播放无等待。',
    },
    {
      icon: 'ri-stack-line',
      title: '海量内容',
      description: '超过10000+高清视频，涵盖十大内容分类，总有你喜欢的。',
    },
    {
      icon: 'ri-24-hours-line',
      title: '每日更新',
      description: '每天都有新鲜视频上架，热门内容第一时间推送。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">为什么选择我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">六大核心优势，打造极致的免费视频观看体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="flex items-start gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-200">
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${feat.icon} text-primary-500 text-lg md:text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}